import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export async function streamChat(path, sessionId, message, onDelta) {
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api${path}`, {
    method: "POST", credentials: "include", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sessionId, message }),
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).detail || "Assistant unavailable");
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) return;
    buf += decoder.decode(value, { stream: true });
    const chunks = buf.split("\n\n");
    buf = chunks.pop();
    for (const chunk of chunks) {
      if (!chunk.startsWith("data: ")) continue;
      const evt = JSON.parse(chunk.slice(6));
      if (evt.error) throw new Error(evt.error);
      if (evt.delta) onDelta(evt.delta);
    }
  }
}

const REMARK_PLUGINS = [remarkGfm];
const MD = "space-y-1.5 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_strong]:text-white [&_code]:font-mono [&_code]:text-[#F3E5AB] [&_a]:text-[#D4AF37] [&_a]:underline [&_table]:text-xs [&_td]:pr-3 [&_th]:pr-3 [&_th]:text-left [&_h3]:font-semibold [&_h3]:text-white";

export const ChatBubble = ({ m }) => (
  <div data-testid={`assistant-msg-${m.role}`} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
    <div className={`max-w-[85%] rounded-lg px-4 py-2.5 text-sm break-words ${m.role === "user" ? "bg-[#D4AF37] text-black" : "bg-[#050505] border border-[#2A2411] text-zinc-200"}`}>
      {m.role === "user" ? m.content : <div className={MD}><ReactMarkdown remarkPlugins={REMARK_PLUGINS}>{m.content || "…"}</ReactMarkdown></div>}
    </div>
  </div>
);
